/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BusinessProfile =
  | 'BUYER'
  | 'SUPPLIER';

export type UpdatePaymentDateMutationVariables = Exact<{
  orderReferenceId: string;
  orderId: string;
  newDate: string;
  updaterBusinessProfile: Types.BusinessProfile;
}>;


export type UpdatePaymentDateMutation = { updatePaymentDate: { orderReferenceId: string } };


export const UpdatePaymentDateDocument = /*#__PURE__*/ gql`
    mutation updatePaymentDate($orderReferenceId: String!, $orderId: String!, $newDate: timestamptz!, $updaterBusinessProfile: BusinessProfile!) {
  updatePaymentDate(
    orderReferenceId: $orderReferenceId
    orderId: $orderId
    newDate: $newDate
    updaterBusinessProfile: $updaterBusinessProfile
  ) {
    orderReferenceId
  }
}
    `;
export type UpdatePaymentDateMutationFn = Apollo.MutationFunction<UpdatePaymentDateMutation, UpdatePaymentDateMutationVariables>;

/**
 * __useUpdatePaymentDateMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentDateMutation, { data, loading, error }] = useUpdatePaymentDateMutation({
 *   variables: {
 *      orderReferenceId: // value for 'orderReferenceId'
 *      orderId: // value for 'orderId'
 *      newDate: // value for 'newDate'
 *      updaterBusinessProfile: // value for 'updaterBusinessProfile'
 *   },
 * });
 */
export function useUpdatePaymentDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentDateMutation, UpdatePaymentDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentDateMutation, UpdatePaymentDateMutationVariables>(UpdatePaymentDateDocument, options);
      }
export type UpdatePaymentDateMutationHookResult = ReturnType<typeof useUpdatePaymentDateMutation>;
export type UpdatePaymentDateMutationResult = Apollo.MutationResult<UpdatePaymentDateMutation>;
export type UpdatePaymentDateMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentDateMutation, UpdatePaymentDateMutationVariables>;